import { useState, useEffect, useRef } from 'react';
import Modal from "@mui/material/Modal";
import Switch from '@mui/material/Switch';
import { useDispatch, useSelector } from 'react-redux';
import AnimatedPage from '../../../components/AnimatedPage';
import { toggleModal } from '../../../reducers/modalReducer';
import { updateLinkedIn } from '../../../reducers/linkedInReducer';
import { useDidAgentStyles } from "../../../hooks/useDidAgentStyles";
import { trackButtonClick, trackPopupOpen, trackPopupClose } from '../../../utils/gtm';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';
import HomeHeroSection from '../../../components/landingPage/HomePageNew/HomeHeroSection';
import HomeLogoStrip from '../../../components/landingPage/HomePageNew/HomeLogoStrip';
import HomeWhatWeDo from '../../../components/landingPage/HomePageNew/HomeWhatWeDo';
import HomeTestimonials from '../../../components/landingPage/HomePageNew/HomeTestimonials';
import HomeCtaSection from '../../../components/landingPage/HomePageNew/HomeCtaSection';

const HomePage = () => {
    const dispatch = useDispatch();
    const modal = useSelector(state => state.modal);
    const rootRef = useRef(null);
    const [isAllServices, setIsAllServices] = useState(true);
    const [isEssentialCookies, setIsEssentialCookies] = useState(true);
    const [isFunctionalCookies, setIsFunctionalCookies] = useState(true);
    const [isPerformanceCookies, setIsPerformanceCookies] = useState(true);

    // Use the hook to apply styles to the shadow root
    useDidAgentStyles();
    useReveal(rootRef);
    useCountUp(rootRef);

    useEffect(() => {
        let hash = location.hash;
        if (hash.includes('linkedIn')) dispatch(updateLinkedIn({ isFromLinkedIn: true }));
        let isCookies = localStorage.getItem("isCookies");
        if (isCookies == null) {
            dispatch(toggleModal({ open: 'cookiesModal' }));
            trackPopupOpen('cookies_modal');
        }
    }, []);

    useEffect(() => {
        // Move the didAgent chatbot into the #chatbot container if both exist
        const targetElement = document.querySelector('.didagent_target');
        const chatbotElement = document.getElementById('chatbot');
        if (targetElement && chatbotElement) chatbotElement.appendChild(targetElement);
        return () => {
            if (targetElement && chatbotElement && targetElement.parentNode === chatbotElement) chatbotElement.removeChild(targetElement);
        };
    }, []);

    const handleSaveCookies = () => {
        dispatch(toggleModal({ open: '' }));
        localStorage.setItem('isCookies', true);
        trackButtonClick('save_cookies', { essential_cookies: isEssentialCookies, functional_cookies: isFunctionalCookies, performance_cookies: isPerformanceCookies, accept_all: isAllServices });
        trackPopupClose('cookies_modal');
    };

    return (
        <AnimatedPage isHomePage={true}>
            <div className="lp-page" ref={rootRef}>
                <HomeHeroSection />
                <HomeLogoStrip />
                <HomeWhatWeDo />
                <HomeTestimonials />
                <HomeCtaSection />
            </div>

            {/* Cookies Popup */}
            <Modal id="cookiesModal" open={modal['open'] == 'cookiesModal'} className="backdrop td500 zi4 pf t0 l0 w100vw  df jcc aic" >
                <div className="poppins-font-style cookies-modal mah100 bg1 shadow w100 df fdc m1rem pr br10px pr" style={{ outline: 'none', maxWidth: '630px', }}>
                    <div className='w100' >
                        <div className="header-area w100">
                            <div className="df jcsb w100 pt1rem pb1rem pl2rem pr2rem bsbb aic">
                                <svg className="back-btn-modal cp" width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.2786 0.40705C7.40543 0.279703 7.55715 0.178129 7.7249 0.10825C7.89264 0.0383717 8.07306 0.00158847 8.25563 4.92302e-05C8.43819 -0.0014881 8.61924 0.0322472 8.78821 0.0992886C8.95719 0.16633 9.1107 0.265335 9.2398 0.390524C9.36889 0.515715 9.47098 0.664585 9.54012 0.828446C9.60925 0.992308 9.64404 1.16788 9.64245 1.34492C9.64087 1.52196 9.60294 1.69692 9.53088 1.85959C9.45882 2.02226 9.35407 2.16939 9.22275 2.29239L4.6951 6.68305L20.6251 6.68305C20.9897 6.68305 21.3394 6.82353 21.5973 7.07358C21.8551 7.32362 22 7.66276 22 8.01638C22 8.37001 21.8551 8.70914 21.5973 8.95919C21.3394 9.20924 20.9897 9.34972 20.6251 9.34972L4.6951 9.34972L9.22275 13.7404C9.47321 13.9919 9.61179 14.3287 9.60866 14.6783C9.60553 15.0278 9.46093 15.3623 9.20601 15.6095C8.95108 15.8567 8.60623 15.9969 8.24573 15.9999C7.88523 16.003 7.53792 15.8686 7.2786 15.6257L0.403938 8.95905C0.275896 8.8352 0.174307 8.68806 0.104993 8.52607C0.0356788 8.36409 0 8.19043 0 8.01505C0 7.83967 0.0356787 7.66602 0.104993 7.50403C0.174307 7.34204 0.275896 7.19491 0.403938 7.07105L7.2786 0.40705Z" fill="#151313" />
                                </svg>
                                <p className="c15 fs1rem fw600">Powered by <span className="tdu">Klaro</span></p>
                            </div>
                        </div>
                        <div className="cookies-box py1rem px3rem" style={{ height: '60vh', overflow: 'auto' }}>
                            <h3 className="c15 fs1-5rem mb1rem">Cookie usage</h3>
                            <p className="c14 pb1rem">In order to enhance your experience across our platforms and show you more relevant information, we use cookies and similar technologies. For more information, see our <a href="/policy" target="_blank" className="cookies-btn fsi c3 tdu cp">Cookie Policy.</a></p>
                            <div className="radiobox-cookies df jcsb w100 aic mt1rem pt-05rem pl1rem pr1rem bsbb br10px" style={{ backgroundColor: '#D1DFFF66' }}>
                                <div className="title-area df aic">
                                    <h4 className="c15 fs1rem">Essential cookies</h4>
                                    <span className="required bg1 c7 bss bw1px bo7 br15px ml1rem w80px fs0-75rem tac">Required</span>
                                </div>
                                <div className="radio-area">
                                    <Switch name='essentialCookies' className="success w100" checked={isEssentialCookies} onChange={() => { setIsEssentialCookies(!isEssentialCookies); trackButtonClick('toggle_essential_cookies', { enabled: !isEssentialCookies }); }} />
                                </div>
                            </div>
                            <div className="radiobox-cookies df jcsb w100 aic mt1rem pt-05rem pl1rem pr1rem bsbb br10px" style={{ backgroundColor: '#D1DFFF66' }}>
                                <div className="title-area df aic">
                                    <h4 className="c15 fs1rem">Functional cookies</h4>
                                </div>
                                <div className="radio-area">
                                    <Switch name='functionalCookies' className="success w100" checked={isFunctionalCookies} onChange={() => { setIsFunctionalCookies(!isFunctionalCookies); trackButtonClick('toggle_functional_cookies', { enabled: !isFunctionalCookies }); }} />
                                </div>
                            </div>
                            <div className="radiobox-cookies df jcsb w100 aic mt1rem pt-05rem pl1rem pr1rem bsbb br10px" style={{ backgroundColor: '#D1DFFF66' }}>
                                <div className="title-area df aic">
                                    <h4 className="c15 fs1rem">Performance cookies</h4>
                                </div>
                                <div className="radio-area">
                                    <Switch name='performanceCookies' className="success w100" checked={isPerformanceCookies} onChange={() => { setIsPerformanceCookies(!isPerformanceCookies); trackButtonClick('toggle_performance_cookies', { enabled: !isPerformanceCookies }); }} />
                                </div>
                            </div>
                            <div className="pt2rem pb1rem divedier"><hr /></div>
                            <div className="radiobox-cookies df jcsb w100 aic mt1rem pt-05rem pl1rem pr1rem bsbb br10px" style={{ backgroundColor: '#D1DFFF66' }}>
                                <div className="title-area df aic">
                                    <h4 className="c15 fs1rem">Accept all services</h4>
                                </div>
                                <div className="radio-area">
                                    <Switch name='allServices' className="success w100" checked={isAllServices} onChange={() => { setIsAllServices(!isAllServices); trackButtonClick('toggle_accept_all_services', { enabled: !isAllServices }); }} />
                                </div>
                            </div>
                            <div className="df jcc w100">
                                <button onClick={() => handleSaveCookies()} className="bg15 bg14-hover w200px p1rem mt2rem c1 br80px cp td250">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </AnimatedPage>
    );
};

export default HomePage;
